import apiClient from './apiClient/infoCollect';

export function getIpAddress() {
  return apiClient.get('ds/getIpAddress.do')
}